import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.5 8a7.5 7.5 0 0 0 12.096 5.928.998.998 0 0 0 .197.28l6 6a1 1 0 0 0 1.414-1.415l-6-6a.998.998 0 0 0-.28-.197A7.5 7.5 0 1 0 .5 8Zm2 0a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }